import { Component, OnInit,OnDestroy, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { IDeltaTable } from '@common/models/Document/IDeltaTable';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { DocumentService } from '@app/services/document.service';
import { IChat } from '@common/models/Chat/IChat';
import { ChatServices } from '@app/services/chat.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ChatType } from '@common/enums/ChatType';
import { getRouteParamChatType } from '@app/utils';

@Component({
  selector: 'app-tables-main',
  templateUrl: './tables-main.component.html',
  styleUrls: ['./tables-main.component.scss'],
  providers: [ MessageService],

})
export class TablesMainComponent implements OnInit,OnDestroy,OnChanges{
  @ViewChildren('tooltip') tooltips: QueryList<any>;

  constructor(
    private readonly docService: DocumentService,
    private readonly chatService: ChatServices,
    private readonly messageService: MessageService,
    private readonly router: Router
  ) {
    this.searchTextUpdate
    .pipe(debounceTime(1000), distinctUntilChanged())
    .subscribe({
        next: (value) => {
            if (this.searchText.trim() != '' || (this.searchText.length==0 && value.key=="Backspace")) {
                this.isloading = true;
                this.getAllDeltaTables('search');
            }
        }
    });
    this.scrollUpdate
    .pipe(debounceTime(300), distinctUntilChanged())
    .subscribe({
        next: (value) => {
            this.scrollLazyLoad(value);
        }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeChatParent']) {
      if(!changes['activeChatParent']?.currentValue){
        this.selectedTables=[]
        this.activeChat=undefined
      }
      if(!this.activeChat || this.activeChat?.chatId !== changes['activeChatParent']?.currentValue?.chatId){
          this.selectedTables=[]
          if(changes['activeChatParent']?.currentValue){
            this.isloading=true
          this.activeChat = changes['activeChatParent'].currentValue
          let tempselectedTables=this.activeChat.chatTables
          if (tempselectedTables?.length > 0 && this.tablesList.length>0) {
            tempselectedTables?.map((e: IDeltaTable) => {
                const foundItem = this.tablesList.find(
                    (tables:IDeltaTable) =>
                      tables.tableId === e.tableId
                );
                if (foundItem) {
                    this.selectedTables.push(foundItem);
                }
            });
          }
          this.isloading = false;}
        }
    }
  }
  displayedColumns: { header: string; field: string }[] = [
    { header: 'Table', field: 'tableName' },
    { header: 'Uploaded At', field: 'createdAt' },
    { header: 'About', field: 'shortSummary' },
  ];
  private chatTypeObsSub: Subscription;
  getAllDocsSub: Subscription = new Subscription();
  createChatSub: Subscription = new Subscription();
  updateChatTablesSub: Subscription = new Subscription();
  isloading: boolean = true;
  pageSize: number = 15;
  showLoadMore: boolean = true;
  loadmoreLoading: boolean = false;
  documentProcessing: DocumentStatus = DocumentStatus.Processing;
  documentProcessed: DocumentStatus = DocumentStatus.Processed;
  documentArchived: DocumentStatus = DocumentStatus.Archived;
  documentFailed: DocumentStatus = DocumentStatus.Failed;
  tablesList: IDeltaTable[] = [];
  selectedTables: IDeltaTable[] = [];
  searchText: string;
  activeChat: IChat;
  searchTextUpdate = new Subject<any>();
  scrollUpdate = new Subject<any>();
  sidebarVisible: boolean = false;
  summaryData: string = '';
  headerSummary: string;
  dialogType: string;
  summaryDocumentName:string;
  deltaTableForSummary:IDeltaTable;
  defaultWFDOTableObsSub: Subscription = new Subscription();
  activeChatObsSub: Subscription = new Subscription();

  chatwithDocs: boolean = false;
  @Input() visible: any;
  @Input() activeChatParent: IChat;

  @Output() visibleChange = new EventEmitter<boolean>(); // Emits changes

  closeDialog() {
    if (globalThis.window !== undefined) {
      const openTooltips = document.querySelectorAll('.p-tooltip');
      openTooltips.forEach((tt: HTMLElement) => {
          tt?.remove();
      });
    }
    if (this.tooltips?.length) {
      this.tooltips.forEach((t: any) => t?.hide?.());
    }
    this.visibleChange.emit(false); // Notify parent that dialog is closed
    this.chatwithDocs=false

  }

  ngOnInit(): void {
    this.getAllDeltaTables()

    this.chatTypeObsSub = this.chatService.getChatTypeObs().subscribe({
      next: (res: ChatType) => {
        if (res === ChatType.QEC && !this.chatService.getActiveChat()) {
          this.docService.setDefaultWFDOTablesList(this.tablesList);
        } else if (this.docService.defaultWFDOTables.length){
          this.docService.setDefaultWFDOTablesList([]);
        }
      }
    });

    this.defaultWFDOTableObsSub = this.docService.getDefaultWFDOTablesListObs()
      .subscribe({
        next: (res: IDeltaTable[]) => {
          if(this.chatService.chatType === ChatType.QEC && !this.chatService.getActiveChat()?.chatId) {
            this.selectedTables = res;
          }
        }
      })

    this.activeChatObsSub = this.chatService.getActiveChatObs().subscribe({
      next: (res: IChat) => {
        // Handling Deletion of WFDO Chat
        if(this.chatService.chatType === ChatType.QEC && !res) {
          this.docService.setDefaultWFDOTablesList(this.tablesList);
        }
      }
    })
  }

  ngOnDestroy() {
    this.getAllDocsSub?.unsubscribe();
    this.createChatSub?.unsubscribe();
    this.updateChatTablesSub?.unsubscribe();
    this.chatTypeObsSub?.unsubscribe();
    this.activeChatObsSub?.unsubscribe();
  }

  updateSidebar(value: boolean) {
    this.sidebarVisible = value;
  }

  showAbout(deltaTableModel:IDeltaTable) {
    this.dialogType = 'sideBar';
    this.summaryDocumentName = deltaTableModel.tableName
    this.deltaTableForSummary = deltaTableModel
    this.headerSummary = 'About';
    this.sidebarVisible = true;
}

truncateSummary(summary: string, maxChars: number): string {
    let tempAbout :any = summary
    summary = String(tempAbout[Object.keys(tempAbout)[0]])
    if (!summary) return '';

    if (summary.length <= maxChars) {
        return summary;
    } else {
        const truncatedSummary = summary.substring(0, maxChars) + '...';
        return truncatedSummary;
    }
}

  getAllDeltaTables(type?: string) {
      this.pageSize=15
      this.showLoadMore = true;
      let tempselectedTables=this.selectedTables
      let params = {
          pageSize: this.pageSize,
      };
      if (type == 'loadmore') {
          this.loadmoreLoading = true;
          params['loadMore']=true
          params['markerId'] = this.tablesList.at(-1)['_id'];

      }
      if (type == 'search') {
          (params['search'] = this.searchText);
      }
      if (type == 'reload') {
          params.pageSize = this.tablesList.length;
          if (this.searchText?.trim()!='') {
              (params['search'] = this.searchText);
          }
      }

      this.getAllDocsSub.add(
          this.docService.getAllDeltaTables(params).subscribe({
              next: (response: IDeltaTable[]) => {
                  this.loadmoreLoading = false;
                  if (response.length < this.pageSize) {
                      this.showLoadMore = false;
                  }
                  if(type == 'reload'||type == 'search' || type=='upload'){
                      this.tablesList=response
                  }else{
                      this.tablesList = [...this.tablesList, ...response];
                  }
                  this.selectedTables=[]
                  if (tempselectedTables?.length > 0 && this.tablesList.length>0) {
                      tempselectedTables?.map((e: IDeltaTable) => {
                          const foundItem = this.tablesList.find(
                              (tables:IDeltaTable) =>
                                tables.tableId === e.tableId
                          );
                          if (foundItem) {
                              this.selectedTables.push(foundItem);
                          }
                      });
                  }
                  this.isloading = false;

                  // Handle Page Refresh for path /chat/qec/new to set default selected WFDO Tables
                  if(!type && !this.activeChat && this.chatService.chatType === ChatType.QEC) {
                    this.docService.setDefaultWFDOTablesList(this.tablesList);
                  }
              },
              error: (error) => {
                  this.loadmoreLoading = false;
                  this.isloading = false;
              },
          })
      );
  }

  checkChatDocs() {
    this.chatwithDocs = true;
    this.activeChat = undefined;
    this.createNewChat();
  }

  createNewChat() {
    this.activeChat = this.chatService.getActiveChat()
    if(this.activeChat?.chatId){
      this.activeChat.chatTables = this.selectedTables;
        if(this.selectedTables.length>0){
          this.attachChatstoDocs(this.selectedTables)
        }
    }else{
      this.createChatSub = this.chatService.createNewChat().subscribe({
          next: (res: IChat) => {
              this.activeChat = res;
              this.getAllDeltaTables('reload');
              this.activeChat.chatTables = this.selectedTables;
              if(this.selectedTables.length>0){
                this.attachChatstoDocs(this.selectedTables)
              }
              void this.router.navigate(['/chat', getRouteParamChatType(this.chatService.chatType), this.activeChat.chatId]);
          }
      });
    }
}

attachChatstoDocs(chatTables:IDeltaTable[]){
  this.updateChatTablesSub.add(
      this.chatService
          .updateChatDocuments([],
              this.activeChat.chatId,
              chatTables
          )
          .subscribe({
              next: (res) => {
                  this.activeChat = res?.data;
                  this.chatService.updateActiveChatObs(res?.data);
                  this.chatService.updateActiveChat(res?.data);
                  this.closeDialog()
                  if(res?.message?.trim() != ''){
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: res?.message,
                    });
                  }
              },
              error: (error) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
              },
          })
  );
}

  scrollLazyLoad(event) {
    let scrollHeightArr = [];
    let shMin = event.target.scrollHeight - 5;
    let shMax = event.target.scrollHeight + 5;
    for (let i = shMin; i < shMax; i++) {
        scrollHeightArr.push(i);
    }
    if (
        scrollHeightArr.includes(
            Math.ceil(event.target.offsetHeight + event.target.scrollTop)
        ) &&
        this.showLoadMore
    ) {
        this.getAllDeltaTables('loadmore');
    }
  }



}
